import { render, staticRenderFns } from "./Respondants.vue?vue&type=template&id=6b1b7c68&scoped=true"
import script from "./Respondants.vue?vue&type=script&lang=js"
export * from "./Respondants.vue?vue&type=script&lang=js"
import style0 from "./Respondants.vue?vue&type=style&index=0&id=6b1b7c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1b7c68",
  null
  
)

export default component.exports